module.exports = __webpack_public_path__ + "static/scale-model-of-all-world-travel-&-tours-in-allen-texas-f00e015c84db4f192f571f0e2bb27230.png";